import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW9004Model } from '../kymw9004.model';

/**
 * 機能一覧を取得する。
 *
 * @export API通信成功時の処理
 * @class GetFunctionListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFunctionListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9004Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFunctionListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetFunctionListService
   */
  execute(model: KYMW9004Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getFunctionList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFunctionListService
   */
  success(data: any) {
    this.model.updateAuthoritySetList(data);
    if ( this.successFunc !== null ) {
      this.successFunc(data);
    }
  }
}
